"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var statusNames = [
    "queued",
    "ringing",
    "in-progress",
    "canceled",
    "completed",
    "busy",
    "failed",
    "no-answer",
];
var is = function (status, list) {
    var index = statusNames.indexOf(status);
    var indexMax = list
        .map(function (e) { return statusNames.indexOf(e); })
        .sort(function (a, b) { return b - a; })[0];
    return indexMax && indexMax >= index;
};
var CallWithStatus = function (call) {
    var expertStatus = (call["callData"]["caller_states"] || []).map(function (e) { return e["state"]; });
    var userStatus = (call["callData"]["callee_states"] || []).map(function (e) { return e["state"]; });
    var status = [
        { key: "callingExpert", value: is("ringing", expertStatus) },
        { key: "expertAnswering", value: is("in-progress", expertStatus) },
        { key: "callingUser", value: is("ringing", userStatus) },
        { key: "userAnswering", value: is("in-progress", userStatus) },
        { key: "finished", value: is("completed", userStatus) },
    ];
    return Object.assign({}, call, {
        status: (status.filter(function (e) { return e.value; })
            .reverse()[0] || { key: "pending" }).key,
        statusList: status,
    });
};
exports.CallWithStatus = CallWithStatus;
//# sourceMappingURL=call-status.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/helpers/call-status.js
// module id = 905
// module chunks = 3